import { render, staticRenderFns } from "./contentCourseLiveAddQuiz.vue?vue&type=template&id=4ff5180a&"
import script from "./contentCourseLiveAddQuiz.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveAddQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports